var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconLogoStyleFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 26,
  viewBox: "0 0 33 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "flag original"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill 49",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 25.4746H32.3604V0.500244H0V25.4746Z",
  fill: "#222222"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill 51",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.79102 22.6788H14.7772V3.29358H2.79102V22.6788Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill 52",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.582 22.6788H29.5682V3.29358H17.582V22.6788Z",
  fill: "white"
}))));
export default SvgIconLogoStyleFlag;